"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenAuthClient = void 0;
const urql_1 = require("urql");
class TokenAuthClient {
    constructor(params) {
        this.params = params;
    }
    getGraphqlClient() {
        const { authToken, apiKey, environment } = this.params;
        return new urql_1.Client({
            url: environment.apiEndpoint,
            fetchOptions: () => {
                const headers = {};
                if (authToken) {
                    headers["Authorization"] = `Bearer ${authToken}`;
                }
                if (apiKey) {
                    headers["X-Niftory-API-Key"] = apiKey;
                }
                return { headers };
            },
            exchanges: [urql_1.cacheExchange, urql_1.fetchExchange],
        });
    }
}
exports.TokenAuthClient = TokenAuthClient;
